import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from '../../../helpers/api_helper';

function* fetchPositionsSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append('unit_id', payload.unit_id);
    const response = yield call(post, process.env.REACT_APP_JOB_SETUP_FETCH_POSITIONS, formData);

    if (response.status !== 'success') throw new Error(response.message || 'Fetch failed');

    yield put({ type: types.FETCH_POSITIONS_SUCCESS, payload: { data: response.data?.position_list || [] } });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_POSITIONS_FAILURE, payload: error });
  }
}

function* savePositionSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_JOB_SETUP_SAVE_POSITION, payload);

    if (response.status !== 'success') throw new Error(response.message || 'Save failed');

    yield put({ type: types.SAVE_POSITION_SUCCESS });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_POSITION_FAILURE, payload: error });
  }
}

function* changePositionStatusSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_JOB_SETUP_CHANGE_POSITION_STATUS, payload);

    if (response.status !== 'success') throw new Error(response.message || 'Status update failed');

    yield put({ type: types.CHANGE_POSITION_STATUS_SUCCESS });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.CHANGE_POSITION_STATUS_FAILURE, payload: error });
  }
}

function* fetchSkillMappingSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append('unit_id', payload.unit_id);
    const response = yield call(post, process.env.REACT_APP_JOB_SETUP_FETCH_SKILL_MAPPING, formData);

    if (response.status !== 'success') throw new Error(response.message || 'Skill Mapping fetch failed');

    yield put({ type: types.FETCH_SKILL_MAPPING_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_SKILL_MAPPING_FAILURE, payload: error });
  }
}

function* saveSkillMappingSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_JOB_SETUP_SAVE_SKILL_MAPPING, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save skill mapping!');
    }

    yield put({ type: types.SAVE_SKILL_MAPPING_SUCCESS });

    Swal.fire({
      title: 'Success',
      text: response?.message,
      icon: 'success',
      confirmButtonText: 'OK',
    });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_SKILL_MAPPING_FAILURE, payload: error });
  }
}

function* changeSkillMappingStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_JOB_SETUP_CHANGE_SKILL_MAPPING_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change skill mapping status!');
    }

    yield put({ type: types.CHANGE_SKILL_MAPPING_STATUS_SUCCESS });

    Swal.fire({
      title: 'Success',
      text: response?.message,
      icon: 'success',
      confirmButtonText: 'OK',
    });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_SKILL_MAPPING_STATUS_FAILURE, payload: error });
  }
}

function* fetchPositionsByDeptRoleSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append('dept_id', payload.departmentId);
    formData.append('role_id', payload.roleId);
    formData.append('unit_id', payload.unit_id);
    const response = yield call(post, process.env.REACT_APP_JOB_SETUP_FETCH_POSITIONS_BY_DEPT_ROLE, formData);

    if (response.status !== 'success') throw new Error(response.message || 'Position fetch failed');

    yield put({ type: types.FETCH_POSITIONS_BY_DEPT_ROLE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_POSITIONS_BY_DEPT_ROLE_FAILURE, payload: error });
  }
}

function* fetchCompetencyListSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append('unit_id', payload.unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_GET_COMPETANCY_LISTS, formData);

    if (response.status !== 'success') throw new Error(response.message || 'Competency list fetch failed');

    yield put({ type: types.FETCH_COMPETENCY_LIST_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_COMPETENCY_LIST_FAILURE, payload: error });
  }
}

export default function* positionSaga() {
  yield takeLatest(types.FETCH_POSITIONS_REQUEST, fetchPositionsSaga);
  yield takeLatest(types.SAVE_POSITION_REQUEST, savePositionSaga);
  yield takeLatest(types.CHANGE_POSITION_STATUS_REQUEST, changePositionStatusSaga);
  yield takeLatest(types.FETCH_SKILL_MAPPING_REQUEST, fetchSkillMappingSaga);
  yield takeLatest(types.SAVE_SKILL_MAPPING_REQUEST, saveSkillMappingSaga);
  yield takeLatest(types.CHANGE_SKILL_MAPPING_STATUS_REQUEST, changeSkillMappingStatusSaga);
  yield takeLatest(types.FETCH_POSITIONS_BY_DEPT_ROLE_REQUEST, fetchPositionsByDeptRoleSaga);
  yield takeLatest(types.FETCH_COMPETENCY_LIST_REQUEST, fetchCompetencyListSaga);
}
